import { FiltersPayloadRow } from 'src/types/CarFilters.types';

export type PendingSavedSearch = {
  filters: FiltersPayloadRow[];
  plpSlug: string;
  typesenseQuery: string;
};

/**
 * Parses the savedSearch URL param from post-login redirect.
 */
export const parsePendingSavedSearchPayload = (raw: string): PendingSavedSearch => {
  const parsed = JSON.parse(raw) as PendingSavedSearch;
  return {
    filters: parsed.filters ?? [],
    plpSlug: parsed.plpSlug ?? '',
    typesenseQuery: parsed.typesenseQuery ?? '',
  };
};
